import React from "react";

const Tag = props => (
	<span
		style={{
			fontSize: "10px",
			fontWeight: 500,
			borderRadius: "4px",
			display: "inline-flex",
			alignItems: "center",
			letterSpacing: props.letterSpacing ? props.letterSpacing : "0.4px",
			padding: "0px 7px",
			height: "21px",
			lineHeight: "10px",
			color: props.color
				? props.color
				: props.type === "success"
				? "#237a41"
				: props.type === "error"
				? "#ff2c2d"
				: props.type === "pending"
				? "#7a6723"
				: props.type === "blue"
				? "#0000ff"
				: props.type === "orange"
				? "#ffa500"
				: props.type === "rto"
				? "rgba(231, 20, 121, 1)"
				: "rgba(143,140,140,1)",
			backgroundColor: props.backgroundColor
				? props.backgroundColor
				: props.type === "success"
				? "#d6fee4"
				: props.type === "error"
				? "rgba(255, 44, 45, 0.15)"
				: props.type === "pending"
				? "rgba(245, 223, 147, 0.20)"
				: props.type === "blue"
				? "rgba(0, 0, 255, 0.3)"
				: props.type === "orange"
				? "rgba(255,165,0, 0.2)"
				: props.type === "rto"
				? "rgba(231, 20, 121, 0.3)"
				: "rgba(157, 162, 171, 0.38)",
		}}
	>
		{props.text}
	</span>
);

export default Tag;
